import {useEffect, useState} from "react";

import {useGetPropertyDetailApplicationQuery} from "../../property/api/get_property_detail";
import {useAppSelector} from "../../store/hooks";

export function useLeadModalConversationFormPriceCheck(check: boolean) {
    const [checkingPrice, setCheckingPrice] = useState(check);
    const propertyId = useAppSelector((state) => state.mainLead.propertyId) as number;

    const {isUninitialized, isFetching} = useGetPropertyDetailApplicationQuery(propertyId);

    const isPropertyDetailsLoading = isUninitialized || isFetching;

    useEffect(() => {
        if (!isPropertyDetailsLoading) {
            setCheckingPrice(false);
        }
    }, [isPropertyDetailsLoading]);

    return checkingPrice;
}
import {useEffect, useState} from "react";

import {useGetPropertyDetailApplicationQuery} from "../../property/api/get_property_detail";
import {useAppSelector} from "../../store/hooks";

export function useLeadModalConversationFormPriceCheck(check: boolean) {
    const [checkingPrice, setCheckingPrice] = useState(check);
    const propertyId = useAppSelector((state) => state.mainLead.propertyId) as number;

    const {isUninitialized, isFetching} = useGetPropertyDetailApplicationQuery(propertyId);

    const isPropertyDetailsLoading = isUninitialized || isFetching;

    useEffect(() => {
        if (!isPropertyDetailsLoading) {
            setCheckingPrice(false);
        }
    }, [isPropertyDetailsLoading]);

    return checkingPrice;
}
